import { createConnectQueryKey, useQuery, UseQueryOptions } from "@connectrpc/connect-query";

import {
  ListSourceSyncsRequest,
  ListSourceSyncsResponse,
} from "@gx/ts-contracts/services/source/api/source_sync_pb";
import { listSourceSyncs } from "@gx/ts-contracts/services/source/api/source_sync-SourceSyncService_connectquery";

// ========== LIST SOURCE SYNCS ==========

export const createListSourceSyncsQueryKey = (input: ListSourceSyncsRequest) => {
  return createConnectQueryKey({
    schema: listSourceSyncs,
    input,
    cardinality: "finite",
  });
};

export const useListSourceSyncsQuery = ({
  input,
  options = {},
}: {
  input: ListSourceSyncsRequest;
  options?: UseQueryOptions<typeof listSourceSyncs.output, ListSourceSyncsResponse>;
}) => {
  return useQuery<typeof listSourceSyncs.input, typeof listSourceSyncs.output>(
    listSourceSyncs,
    input,
    {
      refetchInterval: 5000,
      ...options,
    },
  );
};
